import { Clickable, ClickHandler } from 'dg-web-shared/ui/Clickable';
import { BasicButtonStyle } from 'dg-web-shared/tb-ui/buttons/BasicButton.tsx';
import { css } from '@emotion/css';
import { Typo } from 'dg-web-shared/ui/typo.ts';
import React, { type JSX, useState } from 'react';

export interface ButtonProps {
    onClick: ClickHandler | null;
    label: React.ReactNode;
    disabled?: boolean;
    negative?: boolean;
    primary?: boolean;
    link?: string;
    className?: string;
}

export function MaterialButton({
    onClick,
    label,
    disabled,
    negative,
    primary,
    link,
    className,
}: ButtonProps): JSX.Element {
    const [pressed, setPressed] = useState<boolean>(false);

    function getDepth(): number {
        if (disabled) {
            return 0;
        }
        if (pressed) {
            return 3;
        }
        return 2;
    }

    return (
        <Clickable
            element={link ? 'a' : 'button'}
            target={link && '_blank'}
            href={link || undefined}
            className={css([
                BasicButtonStyle,
                {
                    ...Typo.navbutton,
                    fontSize: '16px',
                    minWidth: '90px',
                },
                className,
            ])}
            onClick={onClick}
            onClickStart={(): void => setPressed(true)}
            onClickEnd={(): void => setPressed(false)}
            data-negative={negative || false}
            data-dark={primary || false}
            data-disabled={disabled || false}
            data-elevation={getDepth()}
            disabled={disabled}
        >
            {label}
        </Clickable>
    );
}
